import { Route } from '@angular/router';
import { FromDriveComponent } from './fromDrive.component';

export const FromDriveRoutes: Route[] = [
  {
    path: 'drive',
    component: FromDriveComponent
  }
];
